import { IConverterToStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { IBehavior } from '../interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import BaseAnimKeyframeHandler from './base-anim-keyframe-handler';
export default class DefaultHandler<T extends IBehavior, M extends IElementBaseModel>
    extends BaseAnimKeyframeHandler<T, M> {
    public parse(
        behavior: T,
        duration: number,
        elementModel: M,
    ): IConverterToStyle | undefined {
        return;
    }
}
